// This icon file is generated automatically.
var OperaOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6.7 4.37a8.72 8.72 0 00-1.86 5.4v.46c.05 2.17.76 4.1 1.87 5.4a7.51 7.51 0 005.95 3.05 7.2 7.2 0 004-1.23A9.94 9.94 0 019.53 20 10 10 0 0110 0h.04c2.54.01 4.86.97 6.63 2.55A7.24 7.24 0 006.7 4.37zM20 10a9.97 9.97 0 01-3.34 7.45 6.04 6.04 0 01-5.74-.17c2.52-.55 4.42-3.6 4.42-7.28s-1.9-6.73-4.42-7.28a6.05 6.05 0 015.74-.17A9.97 9.97 0 0120 10z" } }] }, "name": "opera", "theme": "outlined" };
export default OperaOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/OperaOutlined.js
// module id = 3180
// module chunks = 0